var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabview",style:(_vm.selected ? 'border-bottom: 3px solid #188dff' : ''),on:{"click":function($event){return _vm.$emit('selected', _vm.type)}}},[_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }